const { uidispatcherInternal } = await import("uidispatcher_api/UidispatcherApiModule");
export const Store = uidispatcherInternal.Store;
